import { Route, Routes } from 'react-router-dom'

import Root from './Root'
import { HomePage } from '../../../pages/painel/Home'
import { DatabasePage } from '../../../pages/painel/Database'
import { DatabaseDetail } from '../../../pages/painel/Database/DatabaseDetail'
import { Registers } from '../../../pages/painel/Registers'
import { Expert } from '../../../pages/painel/Registers/modules/Expert'
import { Researcher } from '../../../pages/painel/Registers/modules/Researcher'
import { Client } from '../../../pages/painel/Registers/modules/Client'
import { Asset } from '../../../pages/painel/Registers/modules/Asset'
import { ClientContacts } from '../../../pages/painel/Registers/modules/ClientContacts'
import { AssetAnalyst } from '../../../pages/painel/Registers/modules/AssetAnalyst'
import { AnalystsByAsset } from '../../../pages/painel/Registers/modules/AnalystsByAsset'
import { ProjectsPage } from '../../../pages/painel/Projects'
import { Detail } from '../../../pages/painel/Projects/pages/Detail'
import { ArchivedProjects } from '../../../pages/painel/Projects/pages/ArchivedProjects'
import { Admin } from '../../../pages/painel/Registers/modules/Admin'
import { TermOfParticipation } from '../../../pages/painel/TermOfParticipation'
import { TaskList } from '../../../pages/painel/TaskList'
import { Meetings } from '../../../pages/painel/Meetings'
import { Requests } from '../../../pages/painel/Requests'
import { ChangePassword } from '../../../pages/painel/ChangePassword'
import Interactions from '../../../pages/painel/Interacoes'

const PrivateRoutes = () => {
  return (
    <Routes>
      <Route element={<Root />}>
        <Route path="dashboard" element={<HomePage />} />
        <Route path="change-password" element={<ChangePassword />} />
        <Route path="database" element={<DatabasePage />} />
        <Route path="database/:id" element={<DatabaseDetail />} />
        <Route path="registers" element={<Registers />}>
          <Route path="expert" element={<Expert />} />
          <Route path="admin" element={<Admin />} />
          <Route path="researcher" element={<Researcher />} />
          <Route path="client">
            <Route path=":id/contacts" element={<ClientContacts />} />
            <Route index element={<Client />} />
          </Route>
          <Route path="asset">
            <Route path=":id/analysts" element={<AnalystsByAsset />} />
            <Route index element={<Asset />} />
          </Route>
          <Route path="asset-analyst" element={<AssetAnalyst />} />
          <Route index element={<Expert />} />
        </Route>
        <Route path="projects" element={<ProjectsPage />}>
          <Route path=":id" element={<Detail />} />
          <Route path="archived" element={<ArchivedProjects />} />
          <Route path="archived/:id" element={<Detail />} />
        </Route>
        <Route path="tasklist/:term" element={<TaskList />} />
        <Route path="meetings" element={<Interactions />} />
        <Route path="requests" element={<Requests />} />
        <Route path="term-of-participation" element={<TermOfParticipation />} />
        <Route index element={<HomePage />} />
      </Route>
    </Routes>
  )
}

export default PrivateRoutes
